import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const GoogleAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
        // Initialize GA4
        // We check if the ID exists to avoid errors in dev/testing if not set
        const MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

        if (MEASUREMENT_ID) {
            ReactGA.initialize(MEASUREMENT_ID);
        } else {
            console.warn('GA4 Measurement ID not found in environment variables (VITE_GA_MEASUREMENT_ID)');
        }
    }, []);

    useEffect(() => {
        // Send pageview on route change
        // Only send if initialized implies we might want to check if initialized, 
        // but ReactGA handles this gracefully (logs warning if not init)
        if (import.meta.env.VITE_GA_MEASUREMENT_ID) {
            ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
        }
    }, [location]);

    return null;
};

export default GoogleAnalytics;
